import React from "react";
import type { ISkeletonBoxContext } from "../types";

const skeletonBoxContext = React.createContext<ISkeletonBoxContext | null>(
  null
);
export default skeletonBoxContext;
